var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterChatOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=True, Name=Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5113 6C52.7923 6 65.9907 19.4315 65.9907 36C65.9907 52.5685 52.7923 66 36.5113 66C30.0618 66 24.096 63.8923 19.2428 60.3168L9.70608 63.9567C8.29639 64.4947 6.71751 63.788 6.17955 62.3783C5.95624 61.7932 5.94077 61.149 6.13573 60.5538L9.92499 48.9771C8.07065 45.0499 7.03179 40.6484 7.03179 36C7.03179 19.4315 20.2302 6 36.5113 6ZM24.5921 31.5C22.194 31.5 20.25 33.5147 20.25 36C20.25 38.4853 22.194 40.5 24.5921 40.5C26.9902 40.5 28.9342 38.4853 28.9342 36C28.9342 33.5147 26.9902 31.5 24.5921 31.5ZM36.75 31.5C34.3519 31.5 32.4079 33.5147 32.4079 36C32.4079 38.4853 34.3519 40.5 36.75 40.5C39.1481 40.5 41.0921 38.4853 41.0921 36C41.0921 33.5147 39.1481 31.5 36.75 31.5ZM48.9079 31.5C46.5098 31.5 44.5658 33.5147 44.5658 36C44.5658 38.4853 46.5098 40.5 48.9079 40.5C51.306 40.5 53.25 38.4853 53.25 36C53.25 33.5147 51.306 31.5 48.9079 31.5Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterChatOn);
export default __webpack_public_path__ + "static/media/footer-chat-on.63782c0a3c12ae7b96db2b93ed3f8e35.svg";
export { ForwardRef as ReactComponent };